import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import { Link, Redirect, useHistory } from 'react-router-dom';
import { FaHandPointDown, FaPlus } from 'react-icons/fa';
import './styles/header.css';
import { Language } from '../users';


class Header extends Component {
  constructor() {
    super();
  }

  goBack = () => {
    window.history.back();
  };

  render() {
    const { showUserInfo,showBackButton,showLanguageSwitcher,showCardSwitcher, showTitle, showFeedingInst } = this.props.header;
    const { Translator, language_list, onLangChange, onCardChange, showSideBar } = this.props;
    const translation = Translator;
    return (
    <div className = "header-container">
      <div className = "header">
        <div className = "row">
          <div className = "col-sm-6 col-md-6">
            {showBackButton ? (
              <div id="back_btn" style={{position: "absolute",top: "10px",left: "20px"}}>
                <button style={{background: "hsl(120, 50%, 40%)",border: "0px",position: "relative",float: "left",fontFamily: "Abel",fontSize: "3em",color: "#fff",position: "relative",float: "left",top: "0px",padding: "0px"}} onClick={this.goBack}>←</button>
              </div>
            ) : (
              <div className="toggle-btn" onClick={showSideBar} style = {{position: "absolute",top: "25px",left: "35px"}}>
                <span style = {{position: "relative",width: "30px",height: "5px",backgroundColor: "#fff",display: "block",margin: "5px 0px",overflow: "hidden"}}></span>
                <span style = {{position: "relative",width: "30px",height: "5px",backgroundColor: "#fff",display: "block",margin: "5px 0px",overflow: "hidden"}}></span>
                <span style = {{position: "relative",width: "30px",height: "5px",backgroundColor: "#fff",display: "block",margin: "5px 0px",overflow: "hidden"}}></span>
              </div>
            )}
          </div>
          <div className = "col-sm-6 col-md-6">

            {showCardSwitcher ? (

              <div id="chart_selection" style={{position: "absolute",right: "25px",top: "30px"}}>
              <select  onChange={onCardChange} style={{height: "30px",backgroundColor: "hsl(120, 50%, 40%)",border: "0px",outline: "none",color: "#fff"}} onchange="location=this.value">
                <option value="rch_card">RCH Card</option>
                <option value="book_card">RCH Book</option>
              </select>
              </div>

            ) : (
              
            <div className="language_select" style={{position: "absolute",right: "25px",top: "30px"}}>
              <select onChange={onLangChange} style={{height: "30px",backgroundColor: "hsl(120, 50%, 40%)",border: "0px",outline: "none",color: "#fff"}}>
                {Language.map((language) => (
                  <option value={language.code}>{language.name}</option>
                ))}
              </select>
            </div>
            )}

          </div>
        </div>
      </div>
      <div className = "header-image">
      {showTitle ? (
          <h4 style={{float: "right",paddingTop: "38px",color: "#fff",paddingRight: "5px", fontSize: "1.21em"}} id="logo_title">SMARTGROWTHDIARY</h4>
        ) : showFeedingInst ? (

          <div id="feeding_quest" style={{height: "auto",width: "200px",background: "#336600",float: "right",padding: "10px 0px",borderRadius: "10px",margin: "20px 3px",padding: "10px",color: "#fff",fontSize: "0.8em"}}>
            <p>{translation['feeding_practice_instruction_a']} <span style={{border: "1px solid green",background: "green",color: "#fff",borderRadius: "50%",padding: "2px"}}><FaPlus/></span> {translation['feeding_practice_instruction_b']}.</p>
          </div>

        ) : (

          <div id="food_inst" style={{height: "100%",width: "200px",backgroundColor: "#336600",border: "1px solid #336600",padding: "10px 10px 0px 10px",color: "#fff",float: "right",borderRadius: "10px",fontSize: "0.8em",margin: "15px 3px"}}>
            <p>{translation['feeding_practice_food_info_instruction']}<span style={{paddingLeft: "10px",fontSize: "1.3em",paddingTop: "2px"}}><FaHandPointDown/></span></p>
          </div>

        )}
      </div>
    </div>
    );
  }
}

export default Header;